import React from 'react';

import FormField from 'components/FormField';
import withFormField from 'decorators/withFormField';
import CheckboxInput from 'form-controls/CheckboxInput';

const CheckboxField = withFormField(function CheckboxField(props) {
	const {
		formFieldProps: { label, ...formFieldProps },
		input,
		...other
	} = props;

	return (
		<FormField {...formFieldProps}>
			<CheckboxInput
				{...input}
				{...other}
				disabled={formFieldProps.isDisabled}
				id={formFieldProps.id}
				label={label}
				readOnly={formFieldProps.isReadOnly}
				value={Boolean(input.value)}
			/>
		</FormField>
	);
});

export default CheckboxField;
